export const LineHeightMappingToPx: Record<string, number> = {
  COMPACT: 28,
  SHORT: 32,
  DEFAULT: 40,
  TALL: 58,
  THUMBNAIL: 98,
};
